import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from 'ng2-translate/ng2-translate';

import { AccordionModule } from 'ng2-bootstrap/accordion';
import { AlertModule } from 'ng2-bootstrap/alert';
import { ButtonsModule } from 'ng2-bootstrap/buttons';
import { CarouselModule } from 'ng2-bootstrap/carousel';
import { CollapseModule } from 'ng2-bootstrap/collapse';
import { DropdownModule } from 'ng2-bootstrap/dropdown';
import { ModalModule } from 'ng2-bootstrap/modal';
import { PaginationModule } from 'ng2-bootstrap/pagination';
import { ProgressbarModule } from 'ng2-bootstrap/progressbar';
import { RatingModule } from 'ng2-bootstrap/rating';
import { TabsModule } from 'ng2-bootstrap/tabs';
import { TimepickerModule } from 'ng2-bootstrap/timepicker';
import { TooltipModule } from 'ng2-bootstrap/tooltip';
import { TypeaheadModule } from 'ng2-bootstrap/typeahead';
import { DatepickerModule } from 'ng2-bootstrap/datepicker';

import { EasypiechartDirective } from './directives/easypiechart/easypiechart.directive';
import { FlotDirective } from './directives/flot/flot.directive';
import { SparklineDirective } from './directives/sparkline/sparkline.directive';
import { SvgreplaceDirective } from './directives/svgreplace/svgreplace.directive';
import { VectormapDirective } from './directives/vectormap/vectormap.directive';
import { KnobDirective } from './directives/knob/knob.directive';
import { RippleDirective } from './directives/ripple/ripple.directive';

import { SettingsService } from './settings/settings.service';
import { SettingsComponent } from './settings/settings.component';

import { SelectModule }         from 'ng2-select';
import { DataTableModule }      from 'angular2-datatable';
import { FileUploadModule }     from 'ng2-file-upload';


import * as INGDATALIST         from './data-list';
import * as INGDYNAMICFORM      from './ing-dynamic-form';

// https://angular.io/styleguide#!#04-10
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SelectModule,
    DataTableModule,
    FileUploadModule,
    AccordionModule.forRoot(),
    AlertModule.forRoot(),
    ButtonsModule.forRoot(),
    CarouselModule.forRoot(),
    CollapseModule.forRoot(),
    DatepickerModule.forRoot(),
    DropdownModule.forRoot(),
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    ProgressbarModule.forRoot(),
    RatingModule.forRoot(),
    TabsModule.forRoot(),
    TimepickerModule.forRoot(),
    TooltipModule.forRoot(),
    TypeaheadModule.forRoot()
  ],
  providers: [
    SettingsService
  ],
  declarations: [
    EasypiechartDirective,
    FlotDirective,
    SparklineDirective,
    SvgreplaceDirective,
    VectormapDirective,
    KnobDirective,
    RippleDirective,
    SettingsComponent,
    ...INGDATALIST.default,
    ...INGDYNAMICFORM.default
  ],
  exports: [
    ...INGDATALIST.default,
    ...INGDYNAMICFORM.default,
    SelectModule,
    DataTableModule,
    FileUploadModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    AccordionModule,
    AlertModule,
    ButtonsModule,
    CarouselModule,
    CollapseModule,
    DatepickerModule,
    DropdownModule,
    ModalModule,
    PaginationModule,
    ProgressbarModule,
    RatingModule,
    TabsModule,
    TimepickerModule,
    TooltipModule,
    TypeaheadModule,
    EasypiechartDirective,
    FlotDirective,
    SparklineDirective,
    SvgreplaceDirective,
    VectormapDirective,
    KnobDirective,
    RippleDirective,
    SettingsComponent
  ]
})

// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts